var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      attrs: { "lazy-validation": "" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "v-container",
        { staticClass: "text-center" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("v-text-field", {
                    attrs: {
                      filled: "",
                      "data-cy": "FormDocumentTemplate-name",
                      label: _vm.$$t("name"),
                    },
                    model: {
                      value: _vm.localDocumentTemplate.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.localDocumentTemplate, "name", $$v)
                      },
                      expression: "localDocumentTemplate.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "text-center", attrs: { cols: "12" } },
                [
                  _c("FileUpload", {
                    attrs: {
                      "data-cy": "FormDocumentTemplate-fileUrl",
                      label: "File",
                    },
                    on: { input: _vm.fileUploaded },
                    model: {
                      value: _vm.localDocumentTemplate.fileUrl,
                      callback: function ($$v) {
                        _vm.$set(_vm.localDocumentTemplate, "fileUrl", $$v)
                      },
                      expression: "localDocumentTemplate.fileUrl",
                    },
                  }),
                  _vm.localDocumentTemplate.fileUrl
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "mt-5",
                          attrs: {
                            href: _vm.localDocumentTemplate.fileUrl,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            color: "secondary",
                          },
                        },
                        [
                          _c("v-icon", { attrs: { left: "" } }, [
                            _vm._v(" " + _vm._s(_vm.mdiCloudDownload) + " "),
                          ]),
                          _vm._v(
                            " " +
                              _vm._s(_vm.localDocumentTemplate.filename) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "d-flex justify-end mb-6 mt-5" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ml-4 btn-cancel",
                  attrs: {
                    color: "default",
                    outlined: "",
                    "data-cy": "FormDocumentTemplate-button-cancel",
                  },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.cancel")) + " ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "ml-4",
                  attrs: {
                    color: "primary",
                    type: "submit",
                    loading: _vm.isSaving,
                    "data-cy": "FormDocumentTemplate-button-save",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("common.buttons.save")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }